import React, { createContext, useContext, useReducer } from "react";

export const ScreenContext = createContext(null);
export const ScreenProvider = ({ reducer, initialState, children }) => (
  <ScreenContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </ScreenContext.Provider>
);
export const useScreen = () => useContext(ScreenContext);
